import BroadcastTriggerModel from 'cio/models/broadcast-trigger';
import CampaignModel from 'cio/models/campaign';
import CustomerModel from 'cio/models/customer';
import LogModel from 'cio/models/log';
import NewsletterModel from 'cio/models/newsletter';
import ObjectModel from 'cio/models/object';
import RelationshipModel from 'cio/models/relationship';

export type PreviewVariablesArgs = {
  customer?: CustomerModel['attrs'];
  selectedEvent?: LogModel;
  selectedTrigger?: BroadcastTriggerModel;
  templateVariables: Record<string, any>;
  campaign?: CampaignModel | NewsletterModel;
  objects?: Record<string, ObjectModel['attributes'][]>;
  trigger?: Record<string, CustomerModel['attrs'] | ObjectModel['attributes'] | RelationshipModel['attributes']>;
};

export default function getPreviewVariables({
  customer,
  templateVariables,
  selectedEvent,
  selectedTrigger,
  campaign,
  objects,
  trigger,
}: PreviewVariablesArgs) {
  let variables = { ...templateVariables };

  if (customer) {
    variables.customer = customer;
  }

  if (objects != null && Object.keys(objects).length > 0) {
    variables.objects = objects;
  }

  if (selectedEvent) {
    if (campaign instanceof CampaignModel && campaign?.isWebhookTriggered) {
      variables.trigger_id = selectedEvent.get('id');
      variables.trigger_timestamp = selectedEvent.get('timestamp');
      variables.trigger = selectedEvent.get('attrs');
    } else {
      variables.event_id = selectedEvent.get('id');
      variables.event_name = selectedEvent.get('name');
      variables.event_timestamp = selectedEvent.get('timestamp');
      variables.event = selectedEvent.get('attrs');
    }
  }

  if (selectedTrigger) {
    // @ts-ignore [TODO] Figure out where this sample comes from
    let triggerData = selectedTrigger.sample?.get('triggerData') ?? selectedTrigger.triggerData;
    try {
      variables.trigger = JSON.parse(triggerData);
    } catch (e) {
      // ignore parse failure
    }
  } else if (trigger != null) {
    variables.trigger = trigger;
  }

  return variables;
}
